//js中数字转换成每三位一个逗号的形式
let localSring = value => {
  return value.toLocaleString("en-US");
};
export { localSring };
